
import { ContactForm } from "./ContactForm";
import { ContactInfo } from "./ContactInfo";

export const ContactFormSection = () => {
  return (
    <section id="contact" className="py-24 px-6 bg-gradient-to-b from-white to-[#f0f9ff] relative">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="px-3 py-1 rounded-full bg-[#e0f2fe] text-sm font-medium mb-4 inline-block shadow-sm">
            CONTÁCTANOS
          </span>
          <h2 className="text-3xl md:text-4xl font-display font-medium mb-4 text-[#0c4a6e]">
            Estamos aquí para ayudarte
          </h2>
          <p className="text-lg text-[#0284c7] max-w-2xl mx-auto">
            ¿Tienes preguntas o necesitas una cotización personalizada? Nuestro equipo de expertos está listo para asistirte.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <ContactForm />
          <ContactInfo />
        </div>
      </div>
    </section>
  );
};

export default ContactFormSection;
